import { HardTokenAddController } from '../hard-token-add.controller';

export class Controller extends HardTokenAddController {

    /** @ngInject */
    constructor($state,HardTokenService,Alert) {
        super($state,HardTokenService,Alert);
    }

    $onInit() {
        super.$onInit();
        this.type = 'YUBIKey_USB_KEY';
        this.otpType = 'YOTP';
        this.htUsbAnimHotp= require('./hthotp.gif');
        this.htUsbAnim= require('./htusbanim.gif');
        this.tooltipTemplate = require('./tooltip.html');
        this.tooltipHotpTemplate = require('./tooltip-hotp.html');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/usb-token-add/usb-add.controller.js